import type { AxiosResponse } from "axios";
import type { FieldValues } from "react-hook-form";

import api from "../utils/AxiosInterceptor";

export async function completeTask(
  inputs: FieldValues,
  requestId: string,
  taskId: string,
): Promise<AxiosResponse> {
  return api.post(
    `/api/v1/solicitacoes/${requestId}/tasks/${taskId}/complete`,
    {
      variables: inputs,
    },
  );
}

export async function signAndCompleteTask(
  inputs: FieldValues,
  requestId: string,
  taskId: string,
  otp: string,
): Promise<AxiosResponse> {
  return api.post(
    `/api/v1/solicitacoes/${requestId}/tasks/${taskId}/sign-and-complete-otp`,
    {
      variables: inputs,
      otp,
    },
  );
}

export async function resendOtpTask(
  inputs: FieldValues,
  requestId: string,
  taskId: string,
  email: string,
): Promise<AxiosResponse> {
  return api.post(
    `/api/v1/solicitacoes/${requestId}/tasks/${taskId}/resend-otp`,
    {
      variables: inputs,
      email,
    },
  );
}